module.exports = InternalShared('InternalShared/Events/UpdateProperties');